/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { serializeCreditCardPaymentPostRequest, type CreditCardPaymentPostRequest } from '../../../models';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /creditcards/{creditCardId}/payment
 */
export interface PaymentRequestBuilder extends BaseRequestBuilder<PaymentRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     */
     post(body: CreditCardPaymentPostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreditCardPaymentPostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const PaymentRequestBuilderUriTemplate = "{+baseurl}/creditcards/{creditCardId}/payment";
/**
 * Metadata for all the requests in the request builder.
 */
export const PaymentRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: PaymentRequestBuilderUriTemplate,
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreditCardPaymentPostRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
